const inFlightRequests = new Map<string, Promise<any>>();

async function fetchWithDeduplication<T>(
  key: string,
  apiCall: () => Promise<T>
): Promise<T> {
  if (inFlightRequests.has(key)) {
    return inFlightRequests.get(key)!;
  }

  const promise = apiCall().finally(() => {
    inFlightRequests.delete(key);
  });

  inFlightRequests.set(key, promise);
  return promise;
}

export default fetchWithDeduplication;
